export const site = {
  name: 'Hardware Extraordinaire',
  logo: 'https://cdn.magicpatterns.com/uploads/hHBcsmUn6AyGAjKpFAb1Yp/image.png',
  tagline: 'Hardware, mounting & installation — done to the millimeter.',
  phone: '(512) 555-0142',
  email: 'atelier@hardwareextraordinaire.com',
  serviceArea: 'Austin & the Hill Country',
  hours: 'Mon–Fri 8a–6p · Sat by appointment'
}

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'Process', href: '#process' },
  { label: 'Questions', href: '#faq' }
]

export const stats = [
  { value: '18 yrs', label: 'In finish hardware' },
  { value: '40,000+', label: 'Pieces installed' },
  { value: '1/32"', label: 'Alignment tolerance' },
  { value: '100%', label: 'Clean-site guarantee' }
]

export const process = [
  {
    step: 'I',
    title: 'Consultation',
    body: 'We walk the home or read your plan set, count every door and drawer, and confirm finishes, scale, and backset before a single hole is drilled.'
  },
  {
    step: 'II',
    title: 'Specification',
    body: 'You receive a written schedule: piece, finish, quantity, and placement — sourced through our supplier accounts or matched to what you already own.'
  },
  {
    step: 'III',
    title: 'Installation',
    body: 'Templated, laser-set, and torqued by hand. Floors protected, dust contained, hardware protected in cloth until the final reveal.'
  },
  {
    step: 'IV',
    title: 'The Walkthrough',
    body: 'We open every door with you, adjust every hinge, and leave a care card for the finishes. Anything that shifts in the first year, we return.'
  }
]

export const testimonials = [
  {
    quote:
      'They installed 220 pieces of unlacquered brass in a home where everything is inset. Not one witness mark, not one misaligned pull. I do not let anyone else touch hardware now.',
    name: 'Marguerite Vance',
    role: 'Principal, Vance Interiors'
  },
  {
    quote:
      'The TV, the drapery, the gallery wall, and the smart locks in one afternoon — and the house was cleaner when they left than when they arrived.',
    name: 'Daniel & Priya Rao',
    role: 'Homeowners, Westlake Hills'
  },
  {
    quote:
      'Our punch list used to be full of hardware. We hand them the schedule now and it simply comes back done.',
    name: 'Ross Whitfield',
    role: 'Whitfield Custom Homes'
  }
]

export const faqs = [
  {
    q: 'Do you supply the hardware, or do I?',
    a: 'Either. We sell and source through trade accounts across cabinet, door, and bath hardware, and we are equally happy installing pieces you or your designer have already purchased. If you supply it, we will review the spec first and flag any backset, thickness, or bore issues before install day.'
  },
  {
    q: 'How long does a full house of cabinet hardware take?',
    a: 'A typical kitchen of 40–60 pieces is a single day. A full home of 150–250 pieces is generally two to three days, including hinge adjustment and soft-close conversion. Every piece is templated and drilled to the same tolerance.'
  },
  {
    q: 'Can you convert existing cabinets to soft-close?',
    a: 'Yes. We assess your hinge and slide hardware, then upgrade to concealed soft-close hinges and undermount slides where the cabinet box allows — often without any visible change to the door faces.'
  },
  {
    q: 'Do you install electronic keypads and Wi-Fi locks?',
    a: 'We install and commission keypad and Wi-Fi deadbolts, pair them to your network and app, set up user codes for family and staff, and confirm the strike and jamb are true so the bolt never binds.'
  },
  {
    q: 'Will you mount a television over a fireplace or on brick?',
    a: 'Yes — into studs, masonry, or with blocking added where needed. Cabling is concealed in-wall wherever code and framing permit, and we tune the tilt so the screen is comfortable from the seating position, not just level.'
  },
  {
    q: 'Do you work directly with designers and builders?',
    a: 'Constantly. We read plan sets, produce hardware schedules, coordinate with your cabinet maker on bore locations, and hold to your punch-list dates. Trade pricing is available on supplied hardware.'
  }
]
